export const EmailSecond = ({
  width = '16',
  height = '16',
  color = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5937 2.375H1.40616C1.19616 2.375 0.998625 2.42444 0.819531 2.50728L5.96256 7.66738L5.96366 7.66813L5.96406 7.66894L7.63634 9.34675C7.81397 9.52438 8.18591 9.52438 8.36353 9.34675L10.0355 7.66922L10.0362 7.66813L10.0373 7.66738L15.1802 2.50725C15.0011 2.42438 14.8037 2.375 14.5937 2.375Z"
        fill={color}
      />
      <path
        d="M0.149562 3.1625C0.056875 3.34994 0 3.558 0 3.78088V12.2184C0 12.4412 0.0568125 12.6493 0.149531 12.8367L4.97087 7.99978L0.149562 3.1625Z"
        fill={color}
      />
      <path
        d="M15.8502 3.1625L11.0289 7.99984L15.8502 12.8369C15.9429 12.6494 15.9997 12.4414 15.9997 12.2184V3.78094C15.9997 3.558 15.9429 3.34994 15.8502 3.1625Z"
        fill={color}
      />
      <path
        d="M10.3673 8.66406L9.02731 10.0086C8.48391 10.5539 7.52778 10.5657 6.97263 10.0086L5.63253 8.66406L0.819531 13.4927C0.998688 13.5755 1.19622 13.625 1.40622 13.625H14.5937C14.8037 13.625 15.0012 13.5756 15.1803 13.4927L10.3673 8.66406Z"
        fill={color}
      />
    </svg>
  );
};
